<template>
  <footer>
    <div class="footer-services main-center clearfix">
      <div class="item" v-for="(item, index) in services" :key="index">
        <i :style="{ backgroundImage: `url(${item.icon})` }"></i>
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="footer-links main-center clearfix">
      <div class="links">
        <dl v-for="(item, index) in links" :key="index">
          <dt>{{ item.title }}</dt>
          <dd v-for="(val, key) in item.children" :key="key">
            <a v-if="val.url" :href="val.url">{{ val.title }}</a>
            <span v-else>{{ val.title }}</span>
          </dd>
        </dl>
      </div>
      <div class="contacts">
        <div class="btn-wrap clearfix">
          <a class="btn primary" @click="handleBeforeSale">
            <i></i>
            <span>在线客服</span>
          </a>
          <!-- <a class="btn default" :href="aftersaleLink" target="_blank">
            <i></i>
            <span>售后客服</span>
          </a> -->
        </div>
        <div class="phone">4000-199-199</div>
        <div class="worktime">工作时间：08:30-22:00</div>
        <div class="worktime">(节假日不休)</div>
        <!-- <div class="worktime">工作时间：7*24小时</div> -->
      </div>
    </div>
    <div class="footer-copyright">
      <div class="main-center">
        <br />
        <span
          >copyright © 2017,iflytek Co.,Ltd.All Rights Reserved.
          科大讯飞股份有限公司 版权所有 保留一切权利 |</span
        >
        <a href="http://x.xunfei.cn/mall/privacy.html" target="_blank"
          >隐私政策</a
        >
        |
        <a href="http://x.xunfei.cn/mall/Agreement.html" target="_blank"
          >用户协议</a
        >
        | <span>皖ICP备05001217号</span> |
        <span>皖公网安备 34019202000119号</span> |
        <span>备案主体编号 34201929030521</span>
      </div>
    </div>
    <customer-service :visible.sync="serviceVisible" />
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      services: [
        {
          icon: require('@/assets/svg/iconOne.svg'),
          name: '上市企业 品质保障',
        },
        {
          icon: require('@/assets/svg/iconTwo.svg'),
          name: '快递直达 满99元包邮',
        },
        {
          icon: require('@/assets/svg/iconThree.svg'),
          name: '7天包退15天包换',
        },
        {
          icon: require('@/assets/svg/iconFour.svg'),
          name: '官方售后 365天保修',
        },
        {
          icon: require('@/assets/svg/iconFive.svg'),
          name: '人工客服 专属服务',
        },
      ],
      links: [
        {
          title: '帮助中心',
          children: [
            { title: '隐私政策', url: 'http://x.xunfei.cn/mall/privacy.html' },
            //{ title: '飞粉之家', url: 'https://club.xunfei.cn/' },
          ],
        },
        {
          title: '服务支持',
          children: [
            { title: '讯飞听见', url: 'https://www.iflyrec.com/' },
            { title: '讯飞开放平台', url: 'https://www.xfyun.cn/' },
            { title: '讯飞智声', url: 'http://zhisheng.xunfei.cn/' },
            { title: '讯飞配音', url: 'http://peiyin.xunfei.cn/' },
          ],
        },
        {
          title: '手机软件',
          children: [
            { title: '讯飞输入法', url: 'https://srf.xunfei.cn/' },
            { title: '咪咕灵犀', url: 'http://lingxi.10086.cn/' },
            { title: '讯飞配音', url: 'http://peiyin.xunfei.cn/' },
            {
              title: '讯飞听见',
              url: 'https://www.iflyrec.com/html/activity/appintro.html',
            },
            { title: '讯飞语记', url: 'http://www.iyuji.cn/' },
          ],
        },
        {
          title: '合作应用',
          children: [
            { title: '酷音铃声', url: 'http://www.diyring.cc/' },
            {
              title: '淘云互动',
              url: 'http://www.toycloud.com/contents/18/55.html',
            },
            { title: '方言保护计划', url: 'http://fangyan.xunfei.cn/' },
          ],
        },
        {
          title: '关于我们',
          children: [
            { title: '商城介绍', url: 'http://x.xunfei.cn/mall/about.html' },
            { title: '商务/媒体：xfsc@iflytek.com.cn', url: '' },
          ],
        },
      ],
      qiaoLink:
        'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=53b3e7c8e4e65c26355d5f1f1e12367e&speedLogId=158978440426715a7_1589784404267_52661&eid=24677211&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211420354%22%2C%22userId%22%3A%2224677211%22%2C%22pageId%22%3A0%7D',
      aftersaleLink:
        'https://xffk.iflytek.com/pc/#/?configId=1616546889937',
      serviceVisible: false
    };
  },
  methods: {
    handleBeforeSale() {
      // window.open(ysf('url'));
      this.serviceVisible = true
    }
  }
};
</script>

<style lang="less" scoped>
footer {
  background-color: #fff;
  a:hover {
    color: #00adde;
  }
  .footer-services {
    margin-top: 40px;
    padding: 27px 0;
    border-bottom: 1px solid #e7e7e7;
    .item {
      float: left;
      width: 20%;
      font-size: 18px;
      line-height: 46px;
      text-align: center;
      padding-top: 30px;
      i {
        display: block;
        width: 46px;
        height: 46px;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
      }
      span {
        color: #333;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  .links {
    float: left;
    width: 960px;
    padding: 50px 0 60px;
    dl {
      float: left;
      min-width: 151px;
      dt {
        line-height: 17px;
        height: 47px;
        padding-bottom: 30px;
        font-size: 16px;
        color: #222;
        font-weight: 700;
      }
      dd {
        line-height: 14px;
        padding-bottom: 18px;
        font-size: 14px;
        a,
        span {
          color: #7a7a7a;
        }
        a:hover {
          color: #00adde;
        }
      }
    }
  }

  .contacts {
    float: right;
    width: 240px;
    padding-top: 50px;
    .btn-wrap {
      // height: 70px;
      .btn {
        float: right;
        display: block;
        cursor: pointer;
        width: 160px;
        height: 52px;
        margin-bottom: 26px;
        border-radius: 26px;
        &.primary {
          background: #00adde;
          color: #ffffff;
          i {
            background-image: url('http://img.xunfei.cn/mall/common-resource-img/images/AFT-SALES.png');
          }
        }
        &.default {
          border: 1px solid #cbcbcb;
          color: #747474;
          i {
            margin: 7px 0 15px 25px;
            width: 35px;
            height: 35px;
            background-image: url('http://img.xunfei.cn/mall/common-resource-img/images/AFT-SALE.png');
          }
        }
        i {
          float: left;
          width: 26px;
          height: 24px;
          fill: #666666;
          margin: 15px 0px 15px 30px;
          border: 0px;
          background-size: 100%;
          background-repeat: no-repeat;
        }
        span {
          width: 65px;
          float: right;
          margin: 17px 20px 17px 0px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 16px;
        }
      }
    }
    .phone {
      margin-bottom: 8px;
      line-height: 29px;
      font-family: AvenirLTStd-Roman;
      font-size: 22px;
      color: #171717;
      text-align: right;
    }
    .worktime {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      line-height: 19px;
      color: #999999;
      margin-left: 90px;
      width: 150px;
      text-align: center;
    }
  }
}

.footer-copyright {
  height: 90px;
  background: #fafafa;
  line-height: 25px;
  padding-top: 15px;
  color: #666;
  font-size: 12px;
}
</style>
